import { render, staticRenderFns } from "./DataReporting.vue?vue&type=template&id=711009e2&scoped=true"
import script from "./DataReporting.vue?vue&type=script&lang=js"
export * from "./DataReporting.vue?vue&type=script&lang=js"
import style0 from "./DataReporting.vue?vue&type=style&index=0&id=711009e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711009e2",
  null
  
)

export default component.exports